import { Component, Input } from '@angular/core';
import { Promo } from '../../../models/promo.model';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss']
})
export class PromoComponent {
  @Input() public promo: Promo;
  @Input() title1: string = 'En ce moment';
  @Input() title2: string = 'Promotions Fête des Pères <span style="color: #c39569;">jusqu\'à - 70%</span>';
  @Input() title3: string = 'disponibles jusqu’au 23 Juin';
  @Input() linkUrl: string = '/promotions';
}
